import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-177a0f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-course-id", "data-page-id", "data-part-id", "data-exposure-time"]
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "right" }


import {PageRecord} from "@/models/page/pageRecord";
import {contentRender} from "@/lib/contentRender";
import {Download} from "@/models/page/download";
import {Download as DownloadIcon} from "@element-plus/icons";
import { fetchCommitUseTime } from '@/apis/recorded';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadPage',
  props: {
    page: {},
    userPage: {},
    courseId: {},
    partId: {},
    pageId: {}
  },
  setup(__props: any) {

const props = __props
const handleDownloadClick = (path: string) => {
  fetchCommitUseTime({
    recordedPageId: props.pageId,
    courseId: props.courseId,
    partId: props.partId
  }).then(res=>{
    console.log('fetchCommitUseTime', res)
  })
  window.open(path);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "exposure download-page",
    "data-course-id": _ctx.courseId,
    "data-page-id": _ctx.pageId,
    "data-part-id": _ctx.partId,
    "data-exposure-time": _ctx.userPage.exposureTime
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.page.filename)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "title",
            innerHTML: _unref(contentRender)(_ctx.page.filename),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDownloadClick(_ctx.page.path)))
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "contents-desc",
        innerHTML: _unref(contentRender)(_ctx.page.desc)
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(DownloadIcon), {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleDownloadClick(_ctx.page.path)))
      })
    ])
  ], 8, _hoisted_1))
}
}

})